import { inject, Injectable } from "@angular/core";

import { WidgetPropertiesProvider } from "@wms/design-container";
import { BaseComponent } from "@wms/components";
import {
  loadScripts as _loadScripts,
  getDecodedData,
  isString
} from '@wms/core';
import { MyWidgetsServiceService } from "@wms/app/services/my-widgets-service/my-widgets-service.service";
import { runtimeEventManager } from "@wm/core";
import { widgetRegistry } from "@wavemaker/custom-widgets-m3";

/* callback function when prefab resource is loaded */

@Injectable({
  providedIn: 'root'
})
export class MyWidgetsManager extends BaseComponent {
  private wp: WidgetPropertiesProvider;
  private widgetsExplorer: any

  constructor(private myWidgetsService: MyWidgetsServiceService) {
    super();
    this.wp = inject(WidgetPropertiesProvider);

    runtimeEventManager.setService('MyWidgetsManager', this);

  }

  // TODO: implement WMSPreferences, /editor/scripts/modules/preferences/prefences.js
  // let showPrefabs = $P.hasAccess('components.prefabs');
  processWidgetsForDisplay() {
    let customWidgetsSubGroup: any = this.wp.addSubGroup(
      {
        "name": "custom-widgets",
        "namekey": "LABEL_M3_WIDGETS",
        "parent": "Mywidgets",
        "widgets": [],
        "filteredWidgets": []
      }
    );

    if (customWidgetsSubGroup) {
      customWidgetsSubGroup.widgets = [];
      customWidgetsSubGroup.filteredWidgets = [];
    }

    widgetRegistry.forEach((widget, index) => {
      let widgetData = {
        'id': index + 1,
        'name': widget.displayName,
        'displayName': widget.displayName,
        'desc': widget.desc,
        'iconUrl': '',
        'iconclass': widget.iconClass || 'design-dialog',
        'category': 'custom-widgets',
        'isDraggable': true,
        'widgetType': 'wm-custom-widget',
        'dropEffectCls': 'block wm-prefab',
        'defaults': {
          'widgetName' : widget.name
        },
        'version': '',
        'versionId': "1.0"
      }
      // @ts-ignore
      widgetData['_defaults'] = JSON.stringify(widgetData.defaults);
      customWidgetsSubGroup.widgets.push(widgetData);
      customWidgetsSubGroup.filteredWidgets.push(widgetData);
    })
  }

  loadDependencies(myWidgetName?: string){
    return new Promise((resolve, reject) => {
      this.myWidgetsService.getResources({ widgetName : myWidgetName}).then(widgetContent =>{
        if (isString(widgetContent)) {
          widgetContent = JSON.parse(widgetContent);
        }
        let htmlMarkup = getDecodedData(widgetContent.markup) || '';
        resolve(htmlMarkup)
      })
    })
  }
}
